import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Skeleton } from '@/components/ui/Skeleton';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

const stagger = {
  animate: { transition: { staggerChildren: 0.05 } },
};

export function Authors() {
  const { data, isLoading } = useQuery({
    queryKey: ['authors'],
    queryFn: () => api.authors.getAll(),
  });

  const authors = data?.data || [];

  return (
    <motion.div initial="initial" animate="animate" className="max-w-6xl mx-auto px-4 py-12">
      <motion.div variants={fadeUp}>
        <h1 className="text-4xl font-bold mb-2">Authors</h1>
        <p className="text-surface-500 mb-8">Discover quotes from your favorite authors</p>
      </motion.div>

      {isLoading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} className="h-28 rounded-3xl" />
          ))}
        </div>
      ) : (
        <motion.div variants={stagger} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {authors.map((author: any) => (
            <motion.div key={author.slug} variants={fadeUp}>
              <Link to={`/author/${author.slug}`}>
                <motion.div
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  className="glass-card p-6 flex items-center gap-4 cursor-pointer h-full"
                >
                  <div className="w-14 h-14 rounded-full gradient-bg flex items-center justify-center text-white font-bold text-xl shrink-0">
                    {author.name?.charAt(0)}
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold truncate">{author.name}</p>
                    <p className="text-sm text-surface-500">{author.quote_count || 0} quotes</p>
                  </div>
                </motion.div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      )}
    </motion.div>
  );
}
